module.exports = __webpack_public_path__ + "static/media/7 Male Golden Boot-Ball Trophies.f4352ff6.JPG";